/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MapFilters } from '../../models/map-filters';

export interface GetMapFilters$Params {
}

export function getMapFilters(http: HttpClient, rootUrl: string, params?: GetMapFilters$Params, context?: HttpContext): Observable<StrictHttpResponse<MapFilters>> {
  const rb = new RequestBuilder(rootUrl, getMapFilters.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MapFilters>;
    })
  );
}

getMapFilters.PATH = '/map/filters/types';
